import onGetIcd10Codes from './onGetIcd10Codes';
import onGetMoreIcd10Codes from './onGetMoreIcd10Codes';
import onCreateIcd10Codes from './onCreateIcd10Codes';
import onUpdateIcd10Code from './onUpdateIcd10Code';
import onRemoveIcd10Code from './onRemoveIcd10Code';

export default {
  onGetIcd10Codes,
  onGetMoreIcd10Codes,
  onCreateIcd10Codes,
  onUpdateIcd10Code,
  onRemoveIcd10Code,
};
